import { useEffect, useRef, useState } from 'react';

export const useMaxPolling = (ms: number = 300000) => {
  const isPolling = useRef(false);
  const counter = useRef<number>(0);
  const [maxPollingError, setMaxPollingError] = useState<boolean>(false);
  const [isStarted, setIsStarted] = useState(false);

  useEffect(() => {
    if (!isStarted) return;
    const interval = setInterval(() => {
      if (ms <= counter.current) {
        setMaxPollingError(true);
        clearInterval(interval);
      } else {
        counter.current += 1000;
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [isStarted, ms]);

  const startMaxPolling = (cb: () => void) => {
    if (isPolling.current) return;
    setIsStarted(true);
    isPolling.current = true;
    if (typeof cb === 'function') cb();
  };

  const stopMaxPolling = (cb: () => void) => {
    if (!isPolling.current) return;
    setIsStarted(false);
    isPolling.current = false;
    if (typeof cb === 'function') cb();
  };

  return { startMaxPolling, stopMaxPolling, maxPollingError };
};
